import axios from "axios";
import { getConfig } from "../config/config";

export async function ContagemSimilaridade(token: string, gtin: string, conteudo_liquido: boolean, marca: boolean): Promise<any> {
  try {
    const response = await axios.post(
      getConfig().API_URL + "/contagemSimilaridade",
      {
        gtin: gtin,
        conteudo_liquido: conteudo_liquido,
        marca: marca
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { success: true, message: '', result: response.data };

  } catch (error: any) {
    if (error) {
      return { success: false, message: error.message };
    }
  }

  return { success: false, message: 'Erro desconhecido. Tente novamente mais tarde.', result: '' };
}

export async function ConsultaSimilaridade(token: string, gtin: string, conteudo_liquido: boolean, marca: boolean, pagina: number, confirmar: boolean = false): Promise<any> {
  try {
    const response = await axios.post(
      getConfig().API_URL + "/consultaSimilaridade",
      {
        gtin: gtin,
        conteudo_liquido: conteudo_liquido,
        marca: marca,
        pagina: pagina,
        confirmar: confirmar
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { success: true, message: '', result: response.data };

  } catch (error: any) {
    if (error) {
      return { success: false, message: error.message };
    }
  }

  return { success: false, message: 'Erro desconhecido. Tente novamente mais tarde.', result: '' };
}